<div class="white-wrapper-container">
  <div class="layout-fluid-constrained layout-align-center white-wrapper">
    <div class="s-news-wrapper">
      @if (news) {
        <h1 class="page-name">{{ getTranslation(news)?.name }}</h1>
        @if (news.image) {
          <img [src]="news.image.file | imageBase64Content: news.image.mimeType" class="s-news-image" alt="{{getTranslation(news)?.name}}">
        }
        <div class="date-wrapper">{{ news.date | date: 'dd.MM.yyyy' }}</div>
        <div class="formatted-text text" [innerHTML]="getTranslation(news).text"></div>
      }
    </div>
  </div>
</div>
